const Loader = () => {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-white z-50">
      <div className="relative w-5 h-5 flex justify-center items-center">
        <span className="animate-ping absolute inset-0 rounded-full bg-blue-200 opacity-75"></span>
        <span className="relative rounded-full h-3 w-3 bg-blue-500"></span>
      </div>
    </div>
  );
};

export default Loader;
